<template>
  <v-card class="elevation-0 rounded-0 mt-0">
    <v-card
      id="title_map_rpm"
      v-if="rpmData"
      color="#fff"
      class="ma-3 elevation-0 rounded-0 mt-0 pb-3"
      style="border: solid 1px #e0e0e0"
    >
      <v-card class="elevation-0 rounded-0" color="#fff">
        <v-toolbar
          color="#F7F7F7"
          elevation="0"
          dense
          class="elevation-0 rounded-0"
        >
          <v-toolbar-title> RPM Report </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2 rounded-0 elevation-0"
            fab
            x-small
            color="#F7F7F7"
            @click="closeRpmShow()"
          >
            <v-icon dark> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar color="#F7F7F7" class="elevation-0 rounded-0" dense>
          {{ rpmData.vessel_number }}
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card
          color="#F7F7F7"
          style="border: solid 1px #e0e0e0"
          class="elevation-0 rounded-0 ma-3"
        >
          <v-toolbar color="#F7F7F7" class="elevation-0 rounded-0" dense>
            {{ rpmData.range.range_actual }}
            <v-spacer></v-spacer>
            <v-menu content-class="elevation-0 rounded-0" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="border: solid 1px #e0e0e0"
                  color="#fff"
                  class="elevation-0 rounded-0"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <i class="bx bx-time"></i>
                  &nbsp; &nbsp;
                  <v-text v-if="rpmData">{{ rpmData.range.range }}</v-text>
                  <v-card-text v-if="!rpmData">
                    <div class="snippet" data-title=".dot-pulse">
                      <div class="stage">
                        <div class="dot-pulse"></div>
                      </div>
                    </div>
                  </v-card-text>
                  &nbsp; &nbsp;
                  <i class="bx bxs-chevron-down"></i>
                </v-btn>
              </template>
              <v-list style="border: solid 1px #e0e0e0">
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, 'today')"
                    >Today</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, '24')"
                    >Last 24 Hour</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, '7')"
                    >Last 7 Days</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, '30')"
                    >Last 30 Days</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, 'week')"
                    >This Week</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, 'month')"
                    >This Month</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn block plain small @click="sendDataRPM(rpmID, 'lmonth')"
                    >Last Month</v-btn
                  >
                </v-list-item>
                <v-list-item>
                  <v-btn
                    block
                    plain
                    small
                    @click="(dateopen = true), (datepickerID = rpmID)"
                    >Custom Range</v-btn
                  >
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn
              @click="sendDataRPM(rpmID, 'today')"
              class="mx-2 rounded-0 elevation-0"
              fab
              dark
              x-small
              color="primary"
            >
              <v-icon small dark> mdi-refresh </v-icon>
            </v-btn>
          </v-toolbar>

          <v-card
            style="border: solid 1px #e0e0e0; padding: 10px"
            class="elevation-0 rounded-0 ma-3"
          >
            <RpmChartVue
              v-if="rpmData"
              v-bind:datachart="rpmData.chart"
              v-bind:index="0"
              v-bind:title="'Port RPM 1'"
              v-bind:time_Uptime="portTime_value"
            />
            <RpmChartVue
              v-if="rpmData"
              v-bind:datachart="rpmData.chart"
              v-bind:index="1"
              v-bind:title="'Starboard RPM 2'"
              v-bind:time_Uptime="portTime_value"
            />
          </v-card>

          <v-card
            style="border: solid 1px #e0e0e0; padding: 10px"
            class="elevation-0 rounded-0 ma-3"
          >
            <l-map
              v-if="!rpmData.maptop"
              style="height: 38em; width: 100%"
              ref="mapempty"
              @fullscreenchange="triggerFullscreenEmpty"
              :zoom="6"
              :center="[-0.1292586012050707, 113.39020523630768]"
              :options="{
                minZoom: 3,
                zoomControl: false,
                doubleClickZoom: true,
                scrollWheelZoom: false,
              }"
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-control-zoom position="bottomright"></l-control-zoom>
              <l-control-fullscreen
                position="topright"
                :options="{ title: { false: 'Go big!', true: 'Be regular' } }"
              />
            </l-map>
            <l-map
              v-if="rpmData.maptop"
              @fullscreenchange="triggerFullscreen"
              ref="map"
              :options="{
                minZoom: 3,
                zoomControl: false,
                doubleClickZoom: true,
                scrollWheelZoom: false,
              }"
              style="height: 38em; width: 100%"
              :zoom="8"
              :center="
                rpmData.maptop.lat
                  ? [
                      parseFloat(rpmData.maptop.lat),
                      parseFloat(rpmData.maptop.lon),
                    ]
                  : [-0.1292586012050707, 113.39020523630768]
              "
            >
              <l-tile-layer
                :url="url"
                :attribution="attribution"
              ></l-tile-layer>
              <l-control-zoom position="bottomright"></l-control-zoom>
              <l-control-fullscreen
                position="topright"
                :options="{ title: { false: 'Go big!', true: 'Be regular' } }"
              />
              <v-rotated-marker
                ref="myMarker"
                v-if="rpmData.maptop.lat"
                :lat-lng="[
                  parseFloat(rpmData.maptop.lat),
                  parseFloat(rpmData.maptop.lon),
                ]"
                :rotationAngle="rpmData.maptop.rotation"
              >
                <l-icon
                  :icon-size="[40 / 4, 100 / 4]"
                  :icon-anchor="[40 / 4 / 2, 100 / 4 / 2]"
                  class-name="someExtraClass"
                >
                  <svg
                    id="a"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 100"
                  >
                    <path
                      :fill="rpmData.maptop.fill"
                      stroke="#FFF"
                      stroke-width="10"
                      d="M37.93,32.68L20,0,2.07,32.68c-1.35,2.45-2.07,5.41-2.07,8.44v57.33c0-11.59,8.95-20.99,20-20.99s20,9.4,20,20.99V41.12c0-3.03-.72-5.98-2.07-8.44Z"
                    />
                  </svg>
                </l-icon>
                <l-popup @ready="detailRPM(), draw_Circle()">
                  <table>
                    <tr>
                      <td><b>Latitude</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.maptop.lat }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Longitude</b></td>
                      <td>:</td>
                      <td>{{ rpmData.maptop.lon }}</td>
                    </tr>
                    <tr>
                      <td><b>Heading</b></td>
                      <td>:</td>
                      <td>{{ rpmData.maptop.rotation + "&deg;" }}</td>
                    </tr>
                    <tr>
                      <td><b>Speed</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].speed + "&nbsp;knots" }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Distance</b></td>
                      <td>:</td>
                      <td>{{ rpmData.output[0].distance + " Nmi" }}</td>
                    </tr>
                  </table>
                  <br />
                  <table>
                    <tr>
                      <td></td>
                      <td></td>
                      <td><b>(P)</b> RPM1</td>
                      <td><b>(S)</b> RPM2</td>
                    </tr>
                    <tr>
                      <td><b>Current</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].current.split("/")[0] + " RPM" }}
                      </td>
                      <td>
                        {{ rpmData.output[0].current.split("/")[1] + " RPM" }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Average</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].avg.split("/")[0] + " RPM" }}
                      </td>
                      <td>
                        {{ rpmData.output[0].avg.split("/")[1] + " RPM" }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Min</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].min.split("/")[0] + " RPM" }}
                      </td>
                      <td>
                        {{ rpmData.output[0].min.split("/")[1] + " RPM" }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Max</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].max.split("/")[0] + " RPM" }}
                      </td>
                      <td>
                        {{ rpmData.output[0].max.split("/")[1] + " RPM" }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Uptime</b></td>
                      <td>:</td>
                      <td>
                        {{
                          rpmData.output[0].w_hour.split("/")[0] + " Minutes"
                        }}
                      </td>
                      <td>
                        {{
                          rpmData.output[0].w_hour.split("/")[1] + " Minutes"
                        }}
                      </td>
                    </tr>
                  </table>
                  <br />
                  <table>
                    <tr>
                      <td><b>Interval</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].interval }}
                      </td>
                    </tr>
                  </table>
                  <br />
                  <table>
                    <tr>
                      <td><b>Updated</b></td>
                      <td>:</td>
                      <td>
                        {{ rpmData.output[0].dateTime_local }}
                      </td>
                    </tr>
                  </table>
                </l-popup>
              </v-rotated-marker>
            </l-map>
          </v-card>

          <v-card
            style="border: solid 1px #e0e0e0; padding: 10px"
            class="elevation-0 rounded-0 ma-3"
          >
            <v-toolbar
              style="border: solid 1px #e0e0e0"
              elevation="0"
              class="pa-0"
              color="#F7F7F7"
              fixed
              dense
            >
              <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="border: solid 1px #e0e0e0"
                    small
                    class="rounded-0 pa-1 elevation-0 ma-0 mr-2"
                    color="#ffff"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ kFormatter(itemsPerPageOutput)
                    }}<v-icon small style="margin-left: 0.2em"
                      >mdi-unfold-more-horizontal</v-icon
                    >
                  </v-btn>
                </template>
                <v-list style="border: solid 1px #e0e0e0">
                  <v-list-item @click="itemsPerPageOutput = 10"
                    ><v-list-item-title>10</v-list-item-title></v-list-item
                  >
                  <v-list-item @click="itemsPerPageOutput = 25"
                    ><v-list-item-title>25</v-list-item-title></v-list-item
                  >
                  <v-list-item @click="itemsPerPageOutput = 50"
                    ><v-list-item-title>50</v-list-item-title></v-list-item
                  >
                  <v-list-item @click="itemsPerPageOutput = 100"
                    ><v-list-item-title>100</v-list-item-title></v-list-item
                  >
                </v-list>
              </v-menu>

              <v-btn
                color="primary"
                class="elevation-0 rounded-0"
                @click="createCSV()"
                small
                ><v-icon small>mdi-file-move</v-icon> &nbsp;Export CSV</v-btn
              >
              <v-btn
                color="primary"
                class="elevation-0 rounded-0 ml-3"
                @click="createPDF()"
                small
                ><v-icon small>mdi-file-move</v-icon> &nbsp;Export PDF</v-btn
              >
              <v-spacer style="width: 50%"></v-spacer>
              <v-text-field
                style="border: solid 1px #e0e0e0"
                width="40"
                v-model="searchOutput"
                hide-details
                prepend-inner-icon="mdi-magnify"
                placeholder="Search"
                solo
                clearable
                class="elevation-0 rounded-0"
              ></v-text-field>
            </v-toolbar>
            <v-data-table
              style="border: solid 1px #e0e0e0"
              v-if="rpmOutput"
              :headers="headers"
              :search="searchOutput"
              :items="rpmOutput"
              hide-default-footer
              hide-default-header
              :page.sync="pageOutput"
              :items-per-page="itemsPerPageOutput"
              class="elevation-0 rounded-0 dataTable"
              @page-count="pageCountOutput = $event"
              @pagination="intoFilter"
            >
              <template v-slot:header>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">#</th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Current<br />(RPM)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Average<br />(RPM)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Min<br />(RPM)</th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Max<br />(RPM)</th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Interval<br />(Minutes)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Uptime<br />(Minutes)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Latitude,<br />Longitude
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Heading<br />(Degree)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Speed<br />(Knots)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  Distance<br />(Nmi)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">
                  dateTime<br />(GMT+7)
                </th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_">Detail</th>
                <th class="pa-0 pt-2 pl-1 pb-2 tableHeader_"></th>
              </template>
              <template v-slot:item="row">
                <tr class="pa-0 ma-0">
                  <td
                    width="2%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.index + 1 }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    <b>(P)</b> {{ row.item.current.split("/")[0] }}<br /><b
                      >(S)</b
                    >
                    {{ row.item.current.split("/")[1] }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.avg.split("/")[0] }}<br />{{
                      row.item.avg.split("/")[1]
                    }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.min.split("/")[0] }}<br />{{
                      row.item.min.split("/")[1]
                    }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.max.split("/")[0] }}<br />{{
                      row.item.max.split("/")[1]
                    }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.interval }}
                  </td>
                  <td
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.w_hour.split("/")[0] }}<br />{{
                      row.item.w_hour.split("/")[1]
                    }}
                  </td>
                  <td width="7%" class="pa-0 ma-0" style="text-align: center">
                    {{ row.item.latitude }},{{ row.item.longitude }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.heading }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.speed }}
                  </td>
                  <td
                    width="7%"
                    class="pa-0 ma-0"
                    style="white-space: nowrap; text-align: center"
                  >
                    {{ row.item.distance }}
                  </td>
                  <td width="7%" class="pa-0 ma-0" style="text-align: center">
                    {{ row.item.dateTime_local }}
                  </td>
                  <td width="5%" class="pa-0 ma-0" style="text-align: center">
                    -
                  </td>
                  <td
                    width="7%"
                    style="white-space: nowrap; text-align: center"
                  >
                    <v-btn
                      v-if="row.item.showMap == true"
                      fab
                      dark
                      x-small
                      color="primary"
                      class="mx-2 rounded-0 elevation-0"
                      @click="
                        detailRPMMAP(
                          row.item.latitude,
                          row.item.longitude,
                          row.item
                        )
                      "
                    >
                      <v-icon small dark> mdi-map </v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      fab
                      dark
                      x-small
                      color="#DAE7ED"
                      class="mx-2 rounded-0 elevation-0"
                      style="cursor: not-allowed"
                    >
                      <v-icon small dark> mdi-map </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-toolbar dense class="elevation-0 rounded-0" color="#F7F7F7">
              <p class="mt-3" style="font-size: 0.8em">
                Showing {{ showingDatafromOutput }} to
                {{ showingDatatoOutput }} of {{ totalFilterOutput }} entries
              </p>
              <v-spacer></v-spacer>
              <v-pagination
                color="primary"
                v-model="pageOutput"
                :length="pageCountOutput"
                :total-visible="7"
              ></v-pagination>
            </v-toolbar>
          </v-card>
        </v-card>
      </v-card>
    </v-card>
    <!--Modal Map-->
    <v-dialog v-model="dmap" min-width="90vw" persistent>
      <v-card color="#ffff" class="elevation-0 rounded-0 pb-1">
        <v-toolbar color="#f7f7f7" class="elevation-0 rounded-0" dense>
          <v-col class="header_modal">
            <v-row
              ><v-toolbar-title
                >RPM MAP | {{ rpmData.vessel_number }}
              </v-toolbar-title></v-row
            >
          </v-col>

          <v-spacer></v-spacer>

          <v-btn small class="elevation-0 rounded-0" icon @click="dmap = null">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card
          class="elevation-0 rounded-0 ma-2 mb-1 pa-2"
          style="border: solid 1px #e0e0e0"
        >
          <v-responsive min-width="100%" min-height="60%">
            <v-lazy>
              <client-only>
                <div id="map">
                  <l-map
                    v-if="dmap"
                    @fullscreenchange="triggerFullscreenModal"
                    ref="mapmodal"
                    style="height: 40em"
                    :zoom="8"
                    :center="[parseFloat(dmaplat), parseFloat(dmaplon)]"
                    :options="{
                      minZoom: 3,
                      zoomControl: false,
                      doubleClickZoom: true,
                      scrollWheelZoom: false,
                    }"
                  >
                    <l-tile-layer
                      :url="url"
                      :attribution="attribution"
                    ></l-tile-layer>
                    <l-control-zoom position="bottomright"></l-control-zoom>
                    <l-control-fullscreen
                      position="topright"
                      :options="{
                        title: { false: 'Go big!', true: 'Be regular' },
                      }"
                    />
                    <v-rotated-marker
                      ref="myMarkerMap"
                      :lat-lng="[parseFloat(dmaplat), parseFloat(dmaplon)]"
                      :rotationAngle="rpmData.maptop.rotation"
                    >
                      <l-icon
                        :icon-size="[40 / 4, 100 / 4]"
                        :icon-anchor="[40 / 4 / 2, 100 / 4 / 2]"
                        class-name="someExtraClass"
                      >
                        <svg
                          id="a"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 40 100"
                        >
                          <path
                            :fill="rpmData.maptop.fill"
                            stroke="#FFF"
                            stroke-width="10"
                            d="M37.93,32.68L20,0,2.07,32.68c-1.35,2.45-2.07,5.41-2.07,8.44v57.33c0-11.59,8.95-20.99,20-20.99s20,9.4,20,20.99V41.12c0-3.03-.72-5.98-2.07-8.44Z"
                          />
                        </svg>
                      </l-icon>
                      <l-popup @ready="logReady()">
                        <table>
                          <tr>
                            <td><b>Latitude</b></td>
                            <td>:</td>
                            <td>
                              {{ dmaplat }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Longitude</b></td>
                            <td>:</td>
                            <td>{{ dmaplon }}</td>
                          </tr>
                          <tr>
                            <td><b>Heading</b></td>
                            <td>:</td>
                            <td>{{ dmapdata.rotation + "&deg;" }}</td>
                          </tr>
                          <tr>
                            <td><b>Speed</b></td>
                            <td>:</td>
                            <td>
                              {{ dmapdata.speed + "&nbsp;knots" }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Distance</b></td>
                            <td>:</td>
                            <td>{{ dmapdata.distance + " Nmi" }}</td>
                          </tr>
                        </table>
                        <br />
                        <table>
                          <tr>
                            <td></td>
                            <td></td>
                            <td><b>(P)</b> RPM1</td>
                            <td><b>(S)</b> RPM2</td>
                          </tr>
                          <tr>
                            <td><b>Current</b></td>
                            <td>:</td>
                            <td>
                              {{ dmapdata.current.split("/")[0] + " RPM" }}
                            </td>
                            <td>
                              {{ dmapdata.current.split("/")[1] + " RPM" }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Average</b></td>
                            <td>:</td>
                            <td>{{ dmapdata.avg.split("/")[0] + " RPM" }}</td>
                            <td>{{ dmapdata.avg.split("/")[1] + " RPM" }}</td>
                          </tr>
                          <tr>
                            <td><b>Min</b></td>
                            <td>:</td>
                            <td>{{ dmapdata.min.split("/")[0] + " RPM" }}</td>
                            <td>{{ dmapdata.min.split("/")[1] + " RPM" }}</td>
                          </tr>
                          <tr>
                            <td><b>Max</b></td>
                            <td>:</td>
                            <td>
                              {{ dmapdata.max.split("/")[0] + " RPM" }}
                            </td>
                            <td>
                              {{ dmapdata.max.split("/")[1] + " RPM" }}
                            </td>
                          </tr>
                          <tr>
                            <td><b>Uptime</b></td>
                            <td>:</td>
                            <td>
                              {{ dmapdata.w_hour.split("/")[0] + " Minutes" }}
                            </td>
                            <td>
                              {{ dmapdata.w_hour.split("/")[1] + " Minutes" }}
                            </td>
                          </tr>
                        </table>
                        <br />
                        <table>
                          <tr>
                            <td><b>Interval</b></td>
                            <td>:</td>
                            <td>
                              {{ dmapdata.interval }}
                            </td>
                          </tr>
                        </table>
                        <br />
                        <table>
                          <tr>
                            <td><b>Updated</b></td>
                            <td>:</td>
                            <td>
                              {{ dmapdata.dateTime_local }}
                            </td>
                          </tr>
                        </table>
                      </l-popup>
                    </v-rotated-marker>
                  </l-map>
                </div>
              </client-only>
            </v-lazy>
          </v-responsive>
        </v-card>
      </v-card>
    </v-dialog>
    <!--Modal Map-->

    <v-dialog
      ref="dialog"
      v-model="dateopen"
      :return-value.sync="dates"
      class="elevation-0 rounded-0"
      persistent
      width="290px"
    >
      <v-date-picker
        color="primary"
        class="elevation-0 rounded-0"
        v-model="dates"
        range
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="dateopen = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="customRange()"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
  </v-card>
</template>

<script>
import $ from "jquery";
import RpmChartVue from "../charts/RpmChart.vue";
import { mapSettingsShow } from "@/constants/mapSettings";
import { mapGetters, mapActions } from "vuex";
import Vue2LeafletRotatedMarker from "vue2-leaflet-rotatedmarker";
import { LMap, LTileLayer, LIcon, LPopup, LControlZoom } from "vue2-leaflet";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import LControlFullscreen from "vue2-leaflet-fullscreen";

export default {
  props: ["rpmData", "rpmOutput", "rpmshowclick"],

  components: {
    LMap,
    LTileLayer,
    LIcon,
    LPopup,
    "v-rotated-marker": Vue2LeafletRotatedMarker,
    RpmChartVue,
    LControlZoom,
    LControlFullscreen,
  },

  data() {
    return {
      totalFilterOutput: null,
      time_Uptime: "22",
      dateopen: false,
      dates: [],
      datepickerID: null,
      loadernavplus: require("@/assets/img/load100new.gif"),
      option1: { name: "1" },
      option2: { name: "2" },
      dmap: null,
      dmaplat: null,
      dmaplon: null,
      dmapdata: [],
      headers: [
        {
          text: "#",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Current (RPM)", value: "current" },
        { text: "Average (RPM)", value: "avg" },
        { text: "Min (RPM)", value: "min" },
        { text: "Max (RPM)", value: "max" },
        { text: "Interval (Minutes)", value: "interval" },
        { text: "Uptime (Minutes)", value: "w_hour" },
        { text: "Latitude, Longtitude", value: "latitude" },
        { text: "Heading (Degree)", value: "heading" },
        { text: "Speed (Knots)", value: "speed" },
        { text: "Distance (Nmi)", value: "distance" },
        { text: "dateTime (GMT+7)", value: "dateTime_local" },
        {
          text: "",
          align: "start",
          sortable: false,
          value: "",
        },
      ],
      url: "https://maps.skyreach.id/hot/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 5,
      itemsPerPageOutput: 100,
      pageOutput: 1,
      pageCountOutput: 0,
      searchOutput: "",
    };
  },
  mounted() {
    //  this.$nextTick(() => {
    //   this.detailRPM()
    //  })
    var mama = this;
    if (!mama.rpm_executed) {
      console.log("jalan title map");
      mama.addrpm_executed(true);
      $("html, body").animate(
        {
          scrollTop: $("#title_map_rpm").offset().top - 109,
        },
        800
      );
    } else {
      console.log("Muncul"), console.log(mama.rpm_executed);
    }
  },
  methods: {
    ...mapActions([
      "fetchIot",
      "fetchRpm",
      "removeRpmShow",
      "removeSearchIOT",
      "set_port_time",
      "addrpm_executed",
    ]),
    logReady() {
      this.$refs.myMarkerMap.mapObject.fire("click");
    },

    triggerFullscreen() {
      if (this.$refs["map"].mapObject._isFullscreen != true) {
        this.$refs.map.mapObject.scrollWheelZoom.disable();
      } else {
        this.$refs.map.mapObject.scrollWheelZoom.enable();
      }
    },

    triggerFullscreenModal() {
      if (this.$refs["mapmodal"].mapObject._isFullscreen != true) {
        this.$refs.mapmodal.mapObject.scrollWheelZoom.disable();
      } else {
        this.$refs.mapmodal.mapObject.scrollWheelZoom.enable();
      }
    },

    triggerFullscreenEmpty() {
      if (this.$refs["mapempty"].mapObject._isFullscreen != true) {
        this.$refs.mapempty.mapObject.scrollWheelZoom.disable();
      } else {
        this.$refs.mapempty.mapObject.scrollWheelZoom.enable();
      }
    },

    intoFilter(pagination) {
      this.totalFilterOutput = pagination.itemsLength;
    },

    draw_Circle() {
      var myMap = this.$refs.map.mapObject;
      console.log(this.rpmOutput);

      var data = [];
      for (var i in this.rpmOutput) {
        if(( this.rpmOutput[i].latitude !=null || '-') && ( this.rpmOutput[i].longitude!=null || '-')){
          data.push({
          lat: this.rpmOutput[i].latitude,
          lon: this.rpmOutput[i].longitude,
          heading: this.rpmOutput[i].heading,
          speed: this.rpmOutput[i].speed,
          distance: this.rpmOutput[i].distance,
          current: this.rpmOutput[i].current,
          avg: this.rpmOutput[i].avg,
          min: this.rpmOutput[i].min,
          max: this.rpmOutput[i].max,
          w_hour: this.rpmOutput[i].w_hour,
          interval: this.rpmOutput[i].interval,
          dateTime_local: this.rpmOutput[i].dateTime_local,
        });
        }
       
      }

      console.log(data);

      var latLong = data;
      var pointList = data;
      var mama = this;
      var firstpolyline = new L.Polyline(pointList, {
        color: "#FEE800",
        weight: 4,
        opacity: 1,
        smoothFactor: 1,
      });
      firstpolyline.addTo(myMap);
      // Here's where you iterate over the array of coordinate objects.
      latLong.forEach(function (coord) {
        if (
          coord.lat != mama.rpmData.maptop.lat &&
          coord.lng != mama.rpmData.maptop.lon
        ) {
          var circle = L.circle(coord, {
            color: "#1DC01D",
            fillColor: "#1DC01D",
            fillOpacity: 0.5,
            radius: 1800,
          })
            .addTo(myMap)
            .bindPopup(
              "<table>" +
                "<tr>" +
                "<td><b>Latitude</b></td><td>:</td>" +
                "<td>" +
                coord.lat +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Longitude</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.lon +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Heading</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.heading +
                "</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Speed</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.speed +
                "</td>" +
                "</tr>" +
                "<tr>" +
                " <td><b>Distance</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.distance +
                " Nmi</td>" +
                "</tr>" +
                "</table>" +
                "<br />" +
                "<table>" +
                "<tr>" +
                "<td></td>" +
                "<td></td>" +
                "<td><b>(P)</b> RPM1</td>" +
                "<td><b>(S)</b> RPM2</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Current</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.current.split("/")[0] +
                " RPM</td>" +
                "<td>" +
                coord.current.split("/")[1] +
                " RPM</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Average</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.avg.split("/")[0] +
                " RPM</td>" +
                "<td>" +
                coord.avg.split("/")[1] +
                " RPM</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Min</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.min.split("/")[0] +
                " RPM</td>" +
                "<td>" +
                coord.min.split("/")[1] +
                " RPM</td>" +
                "</tr>" +
                "<tr>" +
                "<td><b>Max</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.max.split("/")[0] +
                " RPM" +
                "</td>" +
                "<td>" +
                +coord.max.split("/")[1] +
                " RPM" +
                "</td>" +
                "</tr>" +
                "<tr>" +
                " <td><b>Uptime</b></td>" +
                "<td>:</td>" +
                "<td>" +
                +coord.w_hour.split("/")[0] +
                " Minutes</td>" +
                "<td>" +
                coord.w_hour.split("/")[1] +
                " Minutes</td>" +
                "</tr>" +
                "</table>" +
                "<br />" +
                "<table>" +
                "<tr>" +
                "<td><b>Interval</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.interval +
                "</td>" +
                "</tr>" +
                "</table>" +
                "<br />" +
                "<table>" +
                "<tr>" +
                "<td><b>Updated</b></td>" +
                "<td>:</td>" +
                "<td>" +
                coord.dateTime_local +
                "</td>" +
                "</tr>" +
                "</table>"
            );
        }
      });
    },

    closeRpmShow() {
      $("html, body").animate(
        {
          scrollTop: $("#top_iot").offset().top - 140,
        },
        800
      );
      this.removeRpmShow();
      this.removeSearchIOT();
      this.addrpm_executed(false);
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    customRange() {
      this.dateopen = false;
      var range_date = this.dates.join(" ");
      console.log(range_date);
      this.sendDataRPM(this.datepickerID, range_date);
    },

    sendDataRPM(id, range) {
      console.log("JALANIN INI rpm nya");
      this.removeRpmShow();
      console.log(id);
      const data = {
        id: id,
        range: range,
        token: localStorage.getItem("token"),
      };
      this.fetchRpm(data);
    },

    createPDF() {
      // let pdfName = parts[0] + "_" + parts[1] + "_Tracking_Reports";
      let pdfName = "test";
      var doc = new jsPDF({
        orientation: "l",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
      });

      doc.setProperties({
        title: pdfName,
        subject: "Its a Subject",
        author: "Me!",
        creator: "My Company Name",
      });

      var output = this.rpmOutput;

      let info = [];
      output.forEach((element) => {
        info.push([
          [element.index + 1],
          [element.current],
          [element.avg],
          [element.speed],
          [element.min],
          [element.max],
          [element.w_hour],
          [element.latitude],
          [element.longitude],
          [element.heading],
          [element.speed],
          [element.distance],
          [element.dateTime_Local],
        ]);
      });

      console.log(info);
      doc.text("RPM Report", 15, 5);
      doc.text(this.rpmData.vessel_number, 15, 10, { fontSize: 9 });

      autoTable(doc, {
        head: [
          [
            "#",
            "Current (RPM)",
            "Average (RPM)",
            "Min (RPM)",
            "Max (RPM)",
            "Interval (Minutes)",
            "Uptime (Minutes)",
            "Latitude, Longitude",
            "Heading (Degree)",
            "Speed (Knots)",
            "Distance (Nmi)",
            "dateTime(GMT+7)",
          ],
        ],
        body: info,
        theme: "striped",
      });

      doc.save(pdfName + ".pdf");
      // doc.output("dataurlnewwindow");
    },

    createCSV() {
      // console.log(this.showmaptable.vessel_pt);
      // var parts = this.showmaptable.vessel_pt.split(" ");
      // console.log(parts);

      // let pdfName = parts[0] + "_" + parts[1] + "_Tracking_Reports";

      let csvName = "Coba";

      var output = this.rpmOutput;
      let data = [];

      output.forEach((element) => {
        data.push([
          [element.index + 1],
          [element.current],
          [element.avg],
          [element.speed],
          [element.min],
          [element.max],
          [element.w_hour],
          [element.latitude],
          [element.longitude],
          [element.heading],
          [element.speed],
          [element.distance],
          [element.dateTime_Local],
        ]);
      });

      let csvContent =
        "data:text/csv;charset=utf-8," +
        data.map((e) => e.join(",")).join("\n");

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", csvName + ".csv");
      document.body.appendChild(link);
      link.click();
    },

    detailRPM() {
      if (this.$refs.myMarker) {
        this.$refs.myMarker.mapObject.fire("click");
      } else {
        console.log("No Marker");
      }
    },

    detailRPMMAP(lat, lon, data) {
      console.log("Open Popup Map");
      this.dmap = true;
      this.dmaplat = lat;
      this.dmaplon = lon;
      this.dmapdata = {
        rotation: 1,
        speed: data.speed,
        distance: data.distance,
        current: data.current,
        avg: data.avg,
        min: data.min,
        max: data.max,
        w_hour: data.w_hour,
        interval: data.interval,
        dateTime_local: data.dateTime_local,
      };
      console.log("Latitude,Longitude Detail Map");
      console.log(this.dmaplat);
      console.log(this.dmaplon);

      //     this.$nextTick(() => {
      //       this.$refs.myMarkerMap.mapObject.fire('click');
      //  })
    },
  },
  computed: {
    ...mapGetters(["rpmData", "rpmShow", "rpmOutput", "rpmID", "rpm_executed"]),
    mapConfig() {
      return {
        ...mapSettingsShow,
        center: this.mapCenter,
      };
    },

    showingDatafromOutput() {
      if (this.totalFilterOutput < 1) {
        return 0;
      } else {
        return 1;
      }
    },

    showingDatatoOutput() {
      if (this.totalFilterOutput < this.itemsPerPageOutput) {
        return this.totalFilterOutput;
      } else {
        return this.itemsPerPageOutput;
      }
    },

    portTime_value() {
      var port = this.rpmOutput;

      console.log("WORKING HOUR");
      let port_minutes = [];
      port.forEach((element) => {
        port_minutes.push([[element.w_hour.split("/")[0]]]);
      });
      console.log(port_minutes);
      console.log(port_minutes.reduce((a, b) => parseInt(a) + parseInt(b), 0));

      var total_port = port_minutes.reduce(
        (a, b) => parseInt(a) + parseInt(b),
        0
      );
      var minutes = total_port;
      var uptime = "";
      var th = Math.floor(minutes / 60);
      if (minutes < 60) {
        uptime = total_port + " Minutes";
      } else if (minutes >= 60 && minutes < 1440) {
        let m = minutes % 60;
        uptime = th + " Hours " + m + " Minutes";
      } else if (minutes >= 1440 && minutes < 43200) {
        let d = Math.floor(minutes / 1440);
        let h = Math.floor((minutes % 1440) / 60);
        let m = minutes % 60;
        uptime =
          d + " Days " + h + " Hours " + m + " Minutes (" + th + " Hours)";
      } else if (minutes > 43200) {
        let mo = Math.floor(minutes / 43200);
        let d = Math.floor((minutes % 43200) / 1440);
        let h = Math.floor((minutes % 1440) / 60);
        let m = minutes % 60;
        uptime =
          mo +
          " Months " +
          d +
          " Days " +
          h +
          " Hours " +
          m +
          " Minutes (" +
          th +
          " Hours)";
      }

      console.log(uptime);
      this.time_Uptime = uptime;
      console.log(this.time_Uptime);
      return uptime;
    },

    mapCenter() {
      return {
        lat: parseFloat(this.rpmData.maptop.lat),
        lng: parseFloat(this.rpmData.maptop.lon),
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
